import {AfterViewInit, Component, OnInit} from '@angular/core';
import {AuthService} from "../../../../shared/services/auth.service";
import {ParamService} from "../../../../shared/services/param.service";
import {ActivatedRoute, Router} from "@angular/router";
import {RewardService} from "../../../../shared/services/reward.service";
import {properties} from "../../../../../environments/properties";
import {RewardsSummaryService} from "../../../../shared/services/rewards-summary.service";
import { LogService } from '../../../../shared/services/LogService';
import { HttpClient } from "@angular/common/http";


declare var $: any;
@Component({
    selector: 'app-mobile-partner-detail',
    templateUrl: './mobile-partner-detail.component.html',
    styleUrls: ['./mobile-partner-detail.component.scss']
})
export class MobilePartnerDetailComponent implements OnInit, AfterViewInit {

    currentEnvironment: string;
    partnerDetails: any;
    userInfo: any;
    appHostURL: any;
    banner: any;
    tokenCaller = 'partners';
    isError = false;
    isLoggedInTokenValid: any;
    tokenObject: any;
    partnerDetailContentURL: any;
    partnerSection: any
    private observer: MutationObserver;
    props = properties;
    public errorMessage: string = "";
    isWebView: boolean = true;

    constructor(public authService: AuthService,
                private rewardService: RewardService,
                private rewardsSummaryService: RewardsSummaryService,
                private paramService: ParamService, private router: ActivatedRoute, private redirectRouter: Router,
                private logService: LogService,
                private http: HttpClient) {
    }

    ngAfterViewInit(): void {
        this.hideCookiesConsent();
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    ngOnInit(): void {
        const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        const receiveMessage = window[eventMethod];
        const messageEvent = 'setPartnerToken';
        const $this = this;
        receiveMessage(messageEvent, function (e) {
            if(e && e.detail && e.detail.partnerPage && e.detail.partnerPage === 'limited-time-offer') {
                if (e.detail.tokenObject) {
                    let mobileRequestObj = e.detail.tokenObject;
                    try {
                        $this.userInfo = mobileRequestObj;
                        if ($this.userInfo && $this.userInfo.token) {
                            $this.logService.log('info', 'Web View : Request Payload : '+ JSON.stringify($this.userInfo), $this.userInfo.env, $this.userInfo.banner);
                            $this.userInfo.authToken = $this.userInfo.token;
                            $this.userInfo.SWY_SHOP_TOKEN = $this.userInfo.token;
                            const isTokenValid = $this.rewardsSummaryService.checkMobileTokenValidity($this.userInfo);
                            $this.logService.log('info', 'Web View : token validity : '+ isTokenValid, $this.userInfo.env, $this.userInfo.banner);

                            if (isTokenValid) {
                                $this.isLoggedInTokenValid = true;
                                $this.currentEnvironment = $this.userInfo.env;
                                $this.banner = $this.userInfo.banner;
                                const storageData =
                                    {
                                        partnerName: $this.userInfo.partnerName,
                                        contentPath: $this.userInfo.contentPath,
                                        partnerOfferId: $this.userInfo.partnerOfferId,
                                        isStatic: $this.userInfo.isStatic,
                                        staticPromo: $this.userInfo.isStatic ? $this.userInfo.staticPromo : null,
                                        userInfo: $this.userInfo,
                                        partnerExternalUrl: $this.userInfo.partnerExternalUrl,
                                        currentEnvironment: $this.userInfo.env,
                                        banner: $this.userInfo.banner,
                                        channelInfo: $this.userInfo.channelInfo
                                    };
                                $this.partnerDetails = storageData;
                                $this.logService.log('info', 'Web View : '+ ' local storage object : '+ JSON.stringify($this.partnerDetails), $this.userInfo.env, $this.userInfo.banner);

                            } else {
                                $this.logService.log('info', 'Web View : '+ ' Token invalid, calling refreshPartnerToken event for Mobile', $this.userInfo.env, $this.userInfo.banner);
                                $this.refreshPartnerToken();
                            }
                        } else {
                            $this.logService.log('info', 'Web View : '+ 'Token missing: calling reDirectBackToPartners event for mobile', $this.userInfo.env, $this.userInfo.banner);
                            //$this.http.post("/ocrp-rewards-ui/log",'Request Payload token missing: calling event reDirectBackToPartners').subscribe();
                            $this.reDirectBackToPartners();
                        }
                    } catch (e) {
                        $this.logService.log('error', 'Web View : '+ ' Invalid Payload, calling refreshPartnerToken event for Mobile', $this.userInfo.env, $this.userInfo.banner);
                        $this.refreshPartnerToken();
                    }

                }
            }

        }, false);
    }

    hideCookiesConsent(): void {
        const bodyNode = document.body;
        const config = { childList: true, subtree: true };

        this.observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === properties.rewardsConfig.childList) {
                    const element = document.getElementById(this.props.rewardsConfig.cookiesOneTrustConsentEle);
                    if (element) {
                        element.style.display = 'none';
                        this.observer.disconnect();
                        break;
                    }
                }
            }
        });

        this.observer.observe(bodyNode, config);
    }

    getPartnerRedeemObject(data){
        if(data){
            switch (data.respCode) {
                case 1 :
                    const responseCodeJson = {
                        status: "ok",
                        isCode: data.isCode,
                        displayPromoCode: data.displayPromoCode,
                        partnerExternalUrl: data.partnerExternalUrl
                    };
                    this.claimPartnersPromotion(responseCodeJson);
                    break;
                case 2 :
                    const responseURLJson = {
                        status: "ok",
                        isCode: data.isCode,
                        partnerExternalUrl: data.partnerExternalUrl,
                    };
                    this.claimPartnersPromotion(responseURLJson)
                    break;
                case 3 :
                    this.reDirectBackToPartners();
                    break;
                case 4:
                    const calBackEventObj = {
                        status: "ok",
                        event: 'privacy-policy',
                        external: true,
                        url: data.url
                    };
                    this.openExternalURL(calBackEventObj)
            }
        }
    }

    refreshPartnerToken() {
        const responseJson = '{"status":"ok"}';
        const event = new CustomEvent('refreshPartnerToken', {detail: responseJson});
        window.dispatchEvent(event);
    }

    reDirectBackToPartners() {
        const responseJson = '{"status":"ok"}';
        const event = new CustomEvent('reDirectBackToPartners', {detail: responseJson});
        window.dispatchEvent(event);
    }

    claimPartnersPromotion(responseJson: any) {
        const event = new CustomEvent('claimPartnersPromotion', {detail: responseJson});
        window.dispatchEvent(event);
    }

    openExternalURL(responseJson: any) {
        const event = new CustomEvent('sendCallbackEvent', {detail: responseJson});
        window.dispatchEvent(event);
    }

}
